import axiosInstance from "../Axios";

interface ResponseData {
  data: {
    message: string;
    user_id: string;
    fname: string;
    lname: string;
    user_type: string;
    view_access_list: string;
    auth_token: string;
  };
}

export async function login(
  user_id: string,
  password: string
): Promise<ResponseData> {
  try {
    const response = await axiosInstance.post("/login", {
      user_id: user_id,
      password: password,
    });
    return response.data;
  } catch (error) {
    return error.data;
  }
}
